import React, { useEffect, useState } from 'react';
import { HOME } from '../../../routes/paths';
import ListView from '../../components/views/listView';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';
import { useAuthContext } from '../../../contexts/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import moment from 'moment';
import SaveIcon from '@mui/icons-material/Save';
import {
    asyncGetActivityTimes,
    asyncPatchActivityTimes,
    asyncPostActivityTime,
} from '../../../services/activityTimes.service';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import { types } from '../../../redux/types';
import { asyncGetStatus } from '../../../services/general.service';
import { getUserLocation } from '../../components/location/getUserLocation';
import AutoCompleteField from '../../components/general/fields/autoCompleteField';

const ListActivityTimes = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { agentIdLog, coords } = useAuthContext();
    const { statusList, ipOrigin } = useSelector(
        (state: RootState) => state.general
    );
    const [rows, setRows] = useState<any>();
    const [row, setRow] = useState<any>();
    const [status, setStatus] = useState<any>(statusList);
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const { titleList, messageNew, messageError } = MasterMessage.activityTimes;
    const currentDate = moment(new Date()).format('YYYY/MM/DD');

    const formik = useFormik({
        initialValues: {
            startTime: null,
            endTime: null,
            agentId: agentIdLog,
            statusId: '',
            latitude: JSON.parse(coords)[1] || '',
            longitude: JSON.parse(coords)[0] || '',
            ip: ipOrigin,
        },
        validationSchema: Yup.object({
            statusId: Yup.string().required('El nuevo estado es obligatorio'),
        }),
        onSubmit: async (formActivityTimes: any) => {
            formActivityTimes.startTime = new Date();
            const body: any = await asyncPostActivityTime(formActivityTimes);
            if (body?.items !== undefined) {
                if (row !== undefined) {
                    asyncPatchActivityTimes(row.id, {
                        endTime: body.items.startTime,
                        agentId: agentIdLog,
                    });
                }
                SwalCustomClass.fire({
                    text: messageNew,
                    icon: 'success',
                    iconColor: '#1d1d1d',
                });
            } else {
                SwalCustomClass.fire({
                    text: messageError,
                    icon: 'error',
                    iconColor: '#1d1d1d',
                });
            }
            setSaveLoad(true);
            setRow(undefined);
            formik.handleReset;
            formik.values.statusId = '';
        },
    });

    useEffect(() => {
        if (statusList.length === 0) {
            asyncGetStatus().then((body: any) => {
                const statuses = Array.isArray(body)
                    ? body
                    : Array.isArray(body?.items)
                      ? body.items
                      : null;
                if (statuses) {
                    dispatch({
                        type: types.uploadStatus,
                        payload: statuses,
                    });
                }
            });
        }

        if (saveLoad && page !== 0) {
            setPage(0);
            setSaveLoad(false);
            return;
        } else if (saveLoad) setSaveLoad(false);

        if (agentIdLog || saveLoad) {
            asyncGetActivityTimes(agentIdLog, currentDate, page, pageSize)
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setRows(body.items.items);
                        setLengthRows(body.items.length);
                        setRow(body.items.items[0]);
                        setStatus(
                            statusList.filter(
                                (s) => s.id !== body.items.items[0].status.id
                            )
                        );
                    }
                })
                .finally(() => setLoading(false));
        }

        getUserLocation().then((lngLat) =>
            dispatch({
                type: types.validationGeolocation,
                payload: lngLat,
            })
        );
    }, [agentIdLog, page, pageSize, saveLoad, statusList]);

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'statudId',
            headerName: 'Estado',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row: any) => {
                return row.row.status.name;
            },
        },
        {
            field: 'startTime',
            headerName: 'Hora Inicio',
            minWidth: 120,
            flex: 0.5,
            type: 'dateTime',
            valueFormatter: (params: any) =>
                moment(params?.value).format('DD/MM/YYYY hh:mm:ss A'),
        },
        {
            field: 'endTime',
            headerName: 'Hora Fin',
            minWidth: 120,
            flex: 0.5,
            type: 'dateTime',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(params?.value).format('DD/MM/YYYY hh:mm:ss A')
                    : null,
        },
    ];

    return (
        <ListView
            title={titleList}
            titleButtonAdd={'Guardar'}
            startIconButtonAdd={<SaveIcon color="secondary" />}
            onClickAdd={formik.handleSubmit}
            onClickBack={() => navigate(HOME)}
            columns={columns}
            rows={rows}
            rowCount={lengthRows}
            disableRow={true}
            loading={loading}
            onSetPage={(paginationModel: any) => paginator(paginationModel)}
            enabledSearch={true}
            searchField={
                <AutoCompleteField
                    data={status}
                    label="Ingrese el nuevo estado"
                    name="statusId"
                    size="small"
                    required={true}
                    touched={formik.touched.statusId}
                    errors={formik.errors.statusId}
                    value={formik.values.statusId}
                    onChangeValue={(value) =>
                        formik.setFieldValue('statusId', value)
                    }
                />
            }
        />
    );
};

export default ListActivityTimes;
